import { Modal } from '@daily/shared/components/Modal';
import { useTranslation } from 'react-i18next';

import { AppsList } from './AppsList';

interface Props extends React.ComponentProps<typeof Modal> {}

export const AppsModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <Modal variant="closable" title={t('general.apps')} {...props}>
      <AppsList iconSize={24} iconVariant="default" textVariant="large" />
    </Modal>
  );
};
